import { apiSlice, axiosBaseQuery } from "api/apiSlice";
import { uploadProgressUpdated } from 'context/pages/pageSlice';
import {
    createSelector,
    createEntityAdapter,
} from "@reduxjs/toolkit";

const pageAdapter = createEntityAdapter({})

const initialState = {
    ...pageAdapter.getInitialState(),
    pagesDetails : {
        page: 0,
        filters: {},
        pagesPerpage: 20,
        total_results: 0
    },
};

export const pageApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPages: builder.query({
            query: params => ({ url: `pages/`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedPage = responseData.pages.map(page => {
                    const newPage = page;
                    /* eslint-disable */
                    return newPage;
                });
                return pageAdapter.setAll(initialState, loadedPage)     
            },
            /* eslint-disable */
            providesTags: (result, error, id) => // [{ type: 'Page', arg }]
             {
                /* eslint-disable */
                if (result?.ids) {
                    return [
                        { type: 'Page', id: 'PARTIAL-LIST' },
                        ...result.ids.map(id => ({ type: 'Page', id }))
                    ]
                } else return [{ type: 'Page', id: 'PARTIAL-LIST' }]
            }
        }),
        getPage: builder.query({
            query: params => ({ url: `/page/${params.id}/` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedPage = responseData;
                return loadedPage
            },
            /* eslint-disable */
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Page', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Page', id }))
                    ]
                } else return [{ type: 'Page', id: 'LIST' }]
            }
        }),
				getSearchResult: builder.query({
					query: params => ({ url: `/search`, params }),
					validateStatus: (response, result) => response.status === 200 && !result.isError,
					transformResponse: responseData => responseData,
				}),
        getPageBySlug : builder.query({
            query: params => ({ url: `/page`, params  }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedPage = responseData.page; 
                pageAdapter.upsertOne(initialState, loadedPage);
                return loadedPage
            },
            /* eslint-disable */
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Page', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Page', id }))
                    ]
                } else return [{ type: 'Page', id: 'LIST' }]
            }
        }),
        addNewPage: builder.mutation({
            query: initialPageData => ({
                url: '/page',
                method: 'POST',
                body: {
                    ...initialPageData,
                }
            }),
            invalidatesTags: (result, error, arg) =>[
                { type: 'Page', id: "LIST" },
                { type: 'Page', id: arg.id }
            ]
        }),
        duplicatePage: builder.mutation({
            query: initialPageData => ({
                url: '/page/duplicate',
                method: 'POST',
                body: {
                    ...initialPageData,
                }
            }),
            invalidatesTags: (result, error, arg) =>[
                { type: 'Page', id: "LIST" },
                { type: 'Page', id: arg.id }
            ]
        }),
        updatePageVisible: builder.mutation({
            query: initialPageData => ({
                url: '/page/visible',
                method: 'PATCH',
                body: {
                    ...initialPageData,
                }
            }),
            invalidatesTags: (result, error, arg) =>[
                { type: 'Page', id: arg.id }
            ]
        }),
        updateColors: builder.mutation({
            query: initialPageData => ({
                url: '/page',
                method: 'PUT',
                body: {
                    ...initialPageData,
                }
            }),
        }),
        updatePage: builder.mutation({
            query: initialPageData => ({
                url: '/page',
                method: 'PATCH',
                body: {
                    ...initialPageData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Page', id: arg.id },
                { type: 'Page', id: "LIST" },
                { type: 'Page', id: 'PARTIAL-LIST' }
            ]
        }),
        deletePage: builder.mutation({
            query: ({ id }) => ({
                url: `/page`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Page', id: arg.id },
                { type: 'Page', id: 'PARTIAL-LIST' },
                { type: 'Page', id: 'LIST' }
            ]
        }),
        updatePagePhoto: builder.mutation({
            query: initialpageData => ({
                url: '/page/upload',
                method: 'POST',
                body: initialpageData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Page', id: arg.id },
                { type: 'Page', id: 'PARTIAL-LIST' },
                { type: 'Page', id: 'LIST' }
            ]
        }),
        deletePagePhoto: builder.mutation({
            query: initialpageData => ({
                url: `/pageUpload`,
                method: 'DELETE',
                body: initialpageData
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Page', id: arg.id },
                { type: 'Page', id: 'PARTIAL-LIST' },
                { type: 'Page', id: 'LIST' }
            ]
        }),
				addNewVideo: builder.mutation({
					queryFn: async (initialVideoData, api) => {
						const controller = new AbortController();
						try {
								return  await axiosBaseQuery({
									url:'/page/videoUpload',
									method:'POST', 
									data : initialVideoData,
									config : {
										signal: controller.signal,	
										onUploadProgress: progressEvent => {
											//Set the progress value to show the progress bar
											let uploadloadProgress = Math.round((100 * progressEvent.loaded) / progressEvent.total);                         
											api.dispatch(uploadProgressUpdated(uploadloadProgress));
										},
										headers : {
											'content-type': 'multipart/form-data'
										}
									}
								});
							} catch (axiosError) {
									let err = axiosError
									return {
										error: {
										status: err.response?.status,
										data: err.response?.data || err.message,
										},
									}
							}
					},
					// invalidatesTags: [
					// 		{ type: 'Page', id: "LIST" }
					// ]
				}),
    }),
})

export const {
    useGetPagesQuery,
    useLazyGetPagesQuery,
    useGetPageQuery,
    useGetPageBySlugQuery,
    useLazyGetPageBySlugQuery,
    useGetSearchResultQuery,
	useLazyGetSearchResultQuery,
    useAddNewPageMutation,
    useDuplicatePageMutation,
    useUpdatePageMutation,
    useUpdateColorsMutation,
    useUpdatePageVisibleMutation,
    useDeletePageMutation,
    useUpdatePagePhotoMutation,
    useDeletePagePhotoMutation,
		useAddNewVideoMutation
} = pageApiSlice

// returns the query result object
export const selectPageResult = pageApiSlice.endpoints.getPages.select()

// creates memoized selector
const selectPageData = createSelector(
    selectPageResult,
    pageResult => pageResult.data // normalized state object with ids & entities
)
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllPages,
    selectById: selectPageById,
    selectIds: selectPageIds
    // Pass in a selector that returns the page slice of state
} = pageAdapter.getSelectors(state => selectPageData(state) ?? initialState)

export const selectPageByUser = createSelector(
    [selectAllPages,(state, userId) => userId],
    (pages, userId) => pages.find(page => page.userId === userId)
);

// new
// const selectPersistedPageData = (state) => state.api.provided.Page;


